var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bm-overlay',{ref:"customOverlay",class:{ sample: true, active: _vm.active },attrs:{"pane":"labelPane"},on:{"draw":_vm.draw}},[_c('div',{staticClass:"name",domProps:{"textContent":_vm._s(_vm.text)},on:{"click":_vm.handleClick}}),_c('div',{staticClass:"mianji"},[_vm._v(" 剩余面积："+_vm._s(_vm.text2)+_vm._s(_vm.danWei == "万平方米" ? "万m²" : "亩")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }